/* eslint-disable @stylistic/object-curly-newline */
import {
  Box,
  Button,
  Chip,
  ChipProps,
  Divider,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import {
  SaveClientReportModal,
  SaveMetaDeliveryModal,
  SaveMetaInspectionModal,
  SaveMetaMilestoneModal
} from 'modules/components/layer17';


import React, {
  ReactElement,
  useState
} from 'react';



export type IClientReportItemType =
'MILESTONE' |
'DELIVERY' |
'INSPECTION' |
'GENERAL';

type IProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

type IBaseModal = (props: IProps) => JSX.Element;

const __reportItemType2Modal: Record<IClientReportItemType, IBaseModal> = {
  MILESTONE: (props: IProps) => <SaveMetaMilestoneModal.FC {...props} />,
  DELIVERY: (props: IProps) => <SaveMetaDeliveryModal.FC {...props} />,
  INSPECTION: (props: IProps) => <SaveMetaInspectionModal.FC {...props} />,
  GENERAL: (props: IProps) => <SaveClientReportModal.FC {...props} />
};


const __reportItemType2Icon: Record<IClientReportItemType, ({ stroke }: { stroke: string }) => ReactElement> = {
  DELIVERY: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='CALENDARALT' stroke={stroke} />,
  GENERAL: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='CALENDARALT' stroke={stroke} />,
  INSPECTION: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='ACCOUNT' stroke={stroke} />,
  MILESTONE: ({ stroke }: { stroke: string }) => <CustomIcon.large.FC icon='CALENDARALT' stroke={stroke} />
};


export type ClientReportItemProps = {
  id: string;
  clientReportId?: string;
  handleInclude?: () => void;
  reportItemType: IClientReportItemType;
  included?: boolean;
  status: {
    variant: ChipProps['variant'];
    label: string;
  };
  title: string;
  quantity?: string;
  clientNotes: string;
  secondaryBox: {
    label: string;
    value: string;
  } | null;
  imageRow: {
    imgUrls: string[];
  } | null;

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportItemProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState<boolean>(false);

  const theme = useTheme();


  const Modal = __reportItemType2Modal[props.reportItemType];
  const Icon = __reportItemType2Icon[props.reportItemType];

  return (
    <>
      {isVisible && (
        <Modal
          id={props.id}
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <Stack
        direction='row'
        columnGap='2rem'
        borderRadius='1rem'
        padding='1rem'
        bgcolor={theme.palette.secondary.main}
      >
        <Stack
          flex='1 1 0'
          direction='column'
          rowGap='.75rem'
        >
          {/* STATUS CHIP */}
          <Chip
            sx={{
              width: 'fit-content'
            }}
            variant={props.status.variant}
            label={props.status.label}
          />
          <Typography
            variant='bodyBold'
          >
            {props.title}
          </Typography>
          {props.quantity && (

            <Typography
              variant='body1'
            >
              Quantity: {props.quantity}
            </Typography>
          )}
        </Stack>
        <Divider
          component='div'

          sx={{
            minHeight: '3rem',
            width: '.1rem',
            background: theme.palette.secondary.dark
          }}
        />
        <Stack
          direction='column'
          rowGap='1.5rem'
          flex='4 1 0'
        >
          <Typography
            variant='formLabel'
          >
            {props.clientNotes}
          </Typography>
          {props.secondaryBox && (
            <Stack
              flexWrap='nowrap'
              alignItems='center'
              direction='row'
              gap='.5rem'
            >
              <>
                <Icon
                  stroke={theme.palette.primary.main}
                />
                <Typography
                  variant='formLabel'
                >
                  {props.secondaryBox.label}
                </Typography>
                <Typography
                  variant='formInput'
                >
                  {props.secondaryBox.value}
                </Typography>
              </>
            </Stack>
          )}
          {props.imageRow && (
            <Stack
              direction='row'
              columnGap='.5rem'
              flexWrap='wrap'
            >
              {props.imageRow.imgUrls.map((node, i) => (
                <Box
                  key={i}
                  borderRadius='.25rem'
                  component='img'
                  src={node}
                  height='7.75rem'
                  width='7.75rem'
                />
              ))}
            </Stack>
          )}
        </Stack>

        <Stack
          direction='row'
          columnGap='.625rem'
        >
          <Button
            variant='contained'
            onClick={() => setIsVisible(() => true)}
            color='primary'
            size='small'
            endIcon={(
              <CustomIcon.large.FC
                icon='EDITSMALLER'
                stroke='#FFFFFF'
              />
            )}
            sx={{
              maxHeight: '2rem'
            }}
          >
            Edit
          </Button>
          <Button
            size='small'
            onClick={() => props.handleInclude && props.handleInclude()}
            color={props.included ? 'error' : 'info'}
            variant='contained'
            sx={{
              maxHeight: '2rem'
            }}
            endIcon={(
              <CustomIcon.large.FC
                icon={(
                  props.included
                    ? 'EYECLOSED'
                    : 'EYEOPEN'
                )}
                stroke='#FFFFFF'
              />
            )}
          >
            {
              props.included
                ? 'Exclude'
                : 'Include'
            }
          </Button>
        </Stack>
      </Stack>
    </>
  );
};
